import * as React from "react";

import errorAccess from "./assets/errorAccess.svg";
import errorGeneral from "./assets/errorGeneral.svg";
import errorInactive from "./assets/errorInactive.svg";
import errorNetwork from "./assets/errorNetwork.svg";
import errorNotFound from "./assets/errorNotFound.svg";

export const AssetsPreload: React.FC = () => {
  return (
    <>
      <img src={errorGeneral} hidden />
      <img src={errorAccess} hidden />
      <img src={errorNetwork} hidden />
      <img src={errorNotFound} hidden />
      <img src={errorInactive} hidden />
    </>
  );
};
